// import './index.scss';

import { pages } from '../../../../pages-list';

import React from 'react';

import { List } from '../../components/list';
import { Link } from '../../components/link';



export function Header() {
  function linkBuilder ( item ) {
    return (
      <Link url={ `${item}.html` } value={ item } key={ item } />
    )
  }

  const links = pages.map(page => linkBuilder(page))
  return (
    <header className='header glass'>
      <nav className='nav'>
        {/* {links} */}
        <List list={ links } ></List>
      </nav>
    </header>
  )
}